<template>
  <div class="news-card" @click="redirectNoticePage(item)">
    <div class="news-card-icon" v-if="item.data.iconNews" :class="defineColor">
      <IconNews :icon="item.data.iconNews"/>
    </div>
    <div class="news-card-info">
      <div class="news-card-header">
        <span class="news-card-label" :class="defineColor" v-if="item.data.taxonomy.length > 0">{{ item.data.taxonomy[0] }}</span>
        <p class="news-card-date" v-if="item && item.data && item.data.created_at">{{ formatCreatedAt(item.data.created_at) }}</p>
      </div>
      <div class="news-card-content" v-if="item.data.shortDescription" v-html="item.data.shortDescription"></div>
    </div>
  </div>
</template>

<script>
  import IconNews from './IconNews.vue';

  export default {
    props:['item'],
    components:{ IconNews },
    computed:{
      defineColor(){
        return this.item.data.colorBgIcon
      }
    },
    methods:{
      redirectNoticePage(news){
        let nextRoute = '/noticias/' + news.id;
        if(this.$route.path !== nextRoute){
          this.$router.push({
            name: 'noticia-detalle',
            params: { id: news.id }
          })
          this.$emit('toggleMenuNews')
        }
      },
      formatCreatedAt(date) {
        const created = this.$moment(date, "YYYY-MM-DD HH:mm:ss");
        const now = this.$moment();

        const hours = now.diff(created, "hours");
        const days = now.diff(created, "days");
        const months = now.diff(created, "months");
        const years = now.diff(created, "years");

        if (hours < 24) {
          return `${hours}h`;
        }

        if (days < 30) {
          return `${days}d`;
        }

        if (months < 12) {
          return `${months}m`;
        }

        return `${years}a`;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/scss/variables.scss';

  .news-card {
    display: flex;
    gap: 10px;
    transition: 0.3s;
    border-radius: 7px;
    padding: 5px;
    cursor: pointer;

    &:hover {
      background-color: $c5;
    }

    .news-card-icon {
      padding: 25px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 84px;
      max-height: 84px;

      &.green {
        background-color: $c4 !important;
      }
      &.orange {
        background-color: $c3 !important;
      }
      &.red {
        background-color: red !important;
      }
      
      img {
        width: 100%;
      }
    }

    .news-card-info {
      display: flex;
      flex-direction: column;
      flex: 1;

      .news-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .news-card-label {
          font-weight: 500;
          padding: 6px 11px;
          background-color: $c4;
          border-radius: 7px;
          width: fit-content;
  
          &.green {
            background-color: $c4 !important;
          }
          &.orange {
            background-color: $c3 !important;
          }
          &.red {
            background-color: red !important;
          }
        }
  
        .news-card-date {
          font-size: 11px;
          font-weight: 400;
          color: $c1;
          margin: 0;
          opacity: 0.4;
        }
      }


      .news-card-content {
        margin-top: 7px;
        max-width: 187px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 14px;
      }
    }
  }
</style>

<style lang="scss">
  @import "@/scss/variables.scss";

  .news-card-icon {
    svg {
      height: 30px;
    }
  }

</style>